// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2RUun","alertIcon":"ConfirmModal_alertIcon__1aIXH"};